import { accessValue } from '../../../core/utils/accessors/access-value.js';
import { applyColorRuleToSingleValue } from '../../core/components/single-value-renderer/utils/apply-color-rule-to-single-value.js';
import { DEFAULT_VALUE_ACCESSOR } from '../../core/constants.js';
import { ColorRuleProps } from '../../core/types/color-rule.js';
import { findMatchingThreshold } from '../../core/utils/find-matching-threshold.js';
import { ARC_DEFAULT_VALUE_COLOR } from '../constants.js';
import { GaugeChartThresholdIndicatorProps } from '../slots/ThresholdIndicator.js';
import type { GaugeChartData } from '../types/gauge-chart.js';

export const getValueArcColor = (
  data: number | GaugeChartData,
  colorRules?: ColorRuleProps[],
  explicitColor?: string,
  thresholds?: GaugeChartThresholdIndicatorProps[],
  valueAccessor?: string,
): string => {
  const displayValue =
    typeof data === 'number'
      ? data
      : accessValue<number>(data, valueAccessor ?? DEFAULT_VALUE_ACCESSOR) ?? 0;

  if (colorRules && colorRules.length > 0) {
    const ruleColor = applyColorRuleToSingleValue(
      colorRules,
      displayValue,
      typeof data === 'number' ? {} : data,
    );
    if (ruleColor) {
      return ruleColor;
    }
  }

  if (thresholds && thresholds.length > 0) {
    const matchingThreshold = findMatchingThreshold(displayValue, thresholds);
    if (matchingThreshold?.color) {
      return matchingThreshold.color;
    }
  }

  if (explicitColor) {
    return explicitColor;
  }

  return ARC_DEFAULT_VALUE_COLOR;
};
